const getDefaultState = () => {
  return {
    errorTitle: "Error",
    successTitle: "Success"
  }
}

const state = getDefaultState();

const actions = {
  triggerSuccess({ commit }, { title, detail }) {
    commit("notify_success", { title, detail });
  },
  triggerError({ commit }, { title, detail }) {
    commit("notify_error", { title, detail });
  },
  resetNotificationState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  notify_success(state, { title, detail }) {
    if (!title) {
      title = state.successTitle;
    }
    this._vm.flashMessage.success({
      title: title,
      message: detail,
      blockClass: "custom-flash-success",
      contentClass: "custom-flash-content",
      time: 8000
    });
  },
  notify_error(state, { title, detail }) {
    if (!title) {
      title = state.errorTitle;
    }
    this._vm.flashMessage.error({
      title: title,
      message: detail,
      blockClass: "custom-flash-error",
      contentClass: "custom-flash-content",
      time: 8000
    });
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const getters = {};

export const notification = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
